import { getMessageByKey } from 'Stores/LanguageStore';

// Configurable anytime-ticket terminology — the multi-pass product a customer buys once and
// redeems per trip. "Anytime Ticket" is a product name rather than a domain concept, so a
// white-label client will want to reword it ("MultiPass", "10-trip pass", …). All four keys are
// editable via the Languages admin. Every user-facing mention of the product goes through one of
// these (#2685) — don't hard-code "anytime ticket" in a string.
export const ANYTIME_TICKET_MESSAGE_KEY = 'general__anytime-ticket__label';
export const ANYTIME_TICKETS_MESSAGE_KEY = 'general__anytime-tickets__label';
export const ANYTIME_TICKET_INLINE_MESSAGE_KEY = 'general__anytime-ticket__inline';
export const ANYTIME_TICKETS_INLINE_MESSAGE_KEY = 'general__anytime-tickets__inline';

const ANYTIME_TICKET_DEFAULT = 'Anytime Ticket';
const ANYTIME_TICKETS_DEFAULT = 'Anytime Tickets';
const ANYTIME_TICKET_INLINE_DEFAULT = 'anytime ticket';
const ANYTIME_TICKETS_INLINE_DEFAULT = 'anytime tickets';

// Every form is read verbatim. getPascalCaseMessageByKey lower-cases the whole string before
// capitalising the first letter, and getLowerCaseMessageByKey lower-cases all of it — either one
// turns "MultiPass" into "Multipass" / "multipass". The casing a client types is the casing they
// want, which is why the mid-sentence form is its own key rather than derived from the label.
const read = (key: string, fallback: string): string => {
	const value = getMessageByKey(key, fallback);
	return value?.trim() ? value : fallback;
};

// Title-cased, e.g. "Anytime Ticket" / "Anytime Tickets" — for headings, tabs and standalone labels.
export const anytimeTicketLabel = (): string => read(ANYTIME_TICKET_MESSAGE_KEY, ANYTIME_TICKET_DEFAULT);

export const anytimeTicketsLabel = (): string => read(ANYTIME_TICKETS_MESSAGE_KEY, ANYTIME_TICKETS_DEFAULT);

// Mid-sentence, e.g. "anytime ticket" / "anytime tickets".
export const anytimeTicketInline = (): string => read(ANYTIME_TICKET_INLINE_MESSAGE_KEY, ANYTIME_TICKET_INLINE_DEFAULT);

export const anytimeTicketsInline = (): string =>
	read(ANYTIME_TICKETS_INLINE_MESSAGE_KEY, ANYTIME_TICKETS_INLINE_DEFAULT);
